import { lazy } from "react";
import { PATHS } from "@/lib/router";

const CustomFrameworkListPage = lazy(() =>
  import("./pages/CustomFrameworkListPage").then((m) => ({
    default: m.CustomFrameworkListPage,
  })),
);
const CustomFrameworkBuilderPage = lazy(() =>
  import("./pages/CustomFrameworkBuilderPage").then((m) => ({
    default: m.CustomFrameworkBuilderPage,
  })),
);

export const customFrameworkRoutes = [
  {
    path: PATHS.CUSTOM_FRAMEWORK_LIST,
    element: <CustomFrameworkListPage />,
    handle: {
      permission: { resource: "custom_framework", action: "view" },
      companyFeatureFlag: "customFrameworkEnabled",
    },
  },
  {
    path: PATHS.CUSTOM_FRAMEWORK_BUILDER,
    element: <CustomFrameworkBuilderPage />,
    handle: {
      permission: { resource: "custom_framework", action: "update" },
      companyFeatureFlag: "customFrameworkEnabled",
    },
  },
];
